/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { propsUtils } from '@ba-ui-toolkit/utils';
import { AccordionItem as CarbonAccordionItem } from 'carbon';

const { sanitize, BaPropTypes } = propsUtils;

export default class AccordionItem extends Component {
	static propTypes = {
		/** Ref for each item header(button) */
		childRef: BaPropTypes.deprecated(' is ignored and not applicable to carbon accordian item'),
		/** Child element(s) inside the item */
		children: PropTypes.node,
		/** extra options for collapse component */
		collapseExtraOptions: BaPropTypes.deprecated(
			' is ignored and not applicable to carbon accordian item'
		),
		/** Disables accordion item */
		disabled: BaPropTypes.deprecated(' is ignored and not applicable to carbon accordian item'),
		/** Where to place icon for the item */
		icon: BaPropTypes.deprecated(' is ignored and not applicable to carbon accordian item'),
		/** Index of each item */
		index: BaPropTypes.deprecated(' is ignored and not applicable to carbon accordian item'),
		/** item label */
		itemName: PropTypes.string,
		/** Callback function when the item is toggled */
		onChange: PropTypes.func,
		/** opens the item */
		open: PropTypes.bool,
		/** Disables parrent element */
		parentDisabled: BaPropTypes.deprecated(
			' is ignored and not applicable to carbon accordian item'
		),
		/** Where to place the parrent element icon */
		parentIcon: BaPropTypes.deprecated(
			' is ignored and not applicable to carbon accordian item'
		),
		/** extra options for the item trigger button */
		triggerButtonExtraOptions: BaPropTypes.deprecated(
			' is ignored and not applicable to carbon accordian item'
		),
	};

	focus() {
		this._node && this._node.focus();
	}

	render() {
		const {
			className,
			disabled,
			parentDisabled,
			icon,
			itemName,
			children,
			parentIcon,
			style,
			triggerButtonExtraOptions,
			collapseExtraOptions,
			childRef,
			index,
			open,
			onChange,
			...others
		} = this.props;

		return (
			<CarbonAccordionItem
				{...sanitize(others, AccordionItem)}
				data-index={index}
				aria-label={itemName}
				title={itemName}
				className={className}
				style={style}
				open={open}
				onHeadingClick={data => onChange && onChange(data.isOpen)}
				ref={r => (this._node = r)}
			>
				{children}
			</CarbonAccordionItem>
		);
	}
}
